import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { PromoBanner } from "../components/PromoBanner";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Manifesto } from "../components/Manifesto";
import { Gallery } from "../components/Gallery";
import { BeforeAfter } from "../components/BeforeAfter";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { EstimateWidget } from "../components/EstimateWidget";
import { ChatWidget } from "../components/ChatWidget";
import { useLenis } from "../hooks/useLenis";

export default function Home() {
  useLenis();
  return (
    <div className="bg-[var(--apex-bg)] min-h-screen">
      <Header />
      <main>
        <Hero />
        <PromoBanner />
        <Marquee />
        <Services />
        <Manifesto />
        <Gallery />
        <BeforeAfter />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <EstimateWidget />
      <ChatWidget />
    </div>
  );
}
